import { Button, CircularProgress, FormControl, Grid, InputAdornment, OutlinedInput, Typography } from "@mui/material";
import React, { Component } from "react";
import LoginImage from "../../assets/images/jm_full_logo.png";
import "./style.css";
import Logo from "../../assets/images/jm_logo.png";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import Cookies from 'js-cookie';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { connect } from 'react-redux';
import { loginUser } from "../../redux/actions/authActions"
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

class LoginComp extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      error: [],
      showPassword: false
    }
  }

  redirectUser = () => {
    this.props.history.push("/dashboard")
  }

  handleLogin = () => {
    const { email, password } = this.state;
    const reEmail =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const rePassword = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    let error = [];

    if (!email.trim()) {
      error.push('email')
    }
    if (!reEmail.test(email.trim())) {
      error.push('emailInvalid')
    }
    if (!password.trim()) {
      error.push('password')
    }
    if (!rePassword.test(password.trim())) {
      error.push('passwordInvalid')
    }

    if (error.length > 0) {
      this.setState({
        error,
      })
    } else {
      this.setState({
        error: [],
      })
      this.props.loginUser(email,password,this.redirectUser)
    }
  }

  componentDidMount() {
    if (Cookies.get('ClisAuthenticated') && Cookies.get('Permissons')) {
      console.log("isAuthenticated");
      this.props.history.push('/dashboard');
          window.location.reload()

    }
  }

 componentWillReceiveProps(nextProps) {
  const isAuth = nextProps?.authData?.isAuthenticated;
  const permissions = Cookies.get('Permissons');

  if (isAuth && permissions) {
    nextProps.history.push('/dashboard');
  }
}

  handleLoginInput = (evt) => {
    this.setState({
      [evt.target.name]: evt.target.value,
    })
  }

  changeView = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    })
  }

  render() {
    const { email, password, error, showPassword } = this.state;
    const { loading } = this.props.authData
    return (
          <div className="main-login">
        <Grid container className="login-container" style={{ height: '100vh', margin: 0 }}>
          <Grid item lg={6} md={6} sm={12} xs={12} className="login-left-side">
            <div className="login-image-wrapper">
              <div className="login-image-content">
                <div className="login-image-overlay">
                  <div className="login-image-shapes">
                    <div className="image-shape image-shape-1"></div>
                    <div className="image-shape image-shape-2"></div>
                    <div className="image-shape image-shape-3"></div>
                  </div>
                </div>
                {LoginImage && (
                  <div className="login-image-container">
                    <img 
                      src={LoginImage}
                      alt="login-illustration"
                      className="login-illustration"
                    />
                  </div>
                )}
                <div className="login-left-content">
                  <Typography className="login-left-title" component="h1">
                    Welcome to <br></br> Jigar Malavaniya & Associates!
                  </Typography>
                  <Typography className="login-left-subtitle">
                    Practice management for inquiries, GST cases, payment recovery, and follow-ups — in one place.
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          
          <Grid item lg={6} md={6} sm={12} xs={12} className="login-right-side">
            <div className="login-form-wrapper">
              <div className="login-form-main">
                {/* <div className="my-meeting-logo">
                  <img 
                    src={Logo}
                    alt="logo"
                  />
                </div> */}
                <div className="welcome-text">
                  <Typography 
                    className="welcome-title" 
                    component="h1"
                  >
                    Welcome Back!
                  </Typography>
                  <Typography 
                    className="welcome-subtitle"
                  >
                    Sign in to your account to continue
                  </Typography>
                </div>
                <form action="" className="form-inputs-main" onSubmit={(e) => { e.preventDefault(); this.handleLogin(); }}>
                  <div className="form-field-wrapper">                
                    <FormControl 
                      className={`form-control ${error?.includes('email') || error?.includes('emailInvalid') ? 'error' : ''}`}
                      fullWidth
                    >

                      <OutlinedInput
                        placeholder="Enter your email"
                        onChange={(evt) => this.handleLoginInput(evt)}
                        className="form-input"
                        type="email"
                        name="email"
                        value={email}
                        startAdornment={
                          <InputAdornment position="start">
                            <PersonIcon className="input-icon" />
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    {error?.includes('email') &&
                      <p className="error-message">
                        Email is required!
                      </p>
                    }
                    {error?.includes('emailInvalid') && !error?.includes('email') &&
                      <p className="error-message">
                        Please enter a valid email address
                      </p>
                    }
                  </div>
                  <div className="form-field-wrapper">
                    <FormControl 
                      className={`form-control ${error?.includes('password') || error?.includes('passwordInvalid') ? 'error' : ''}`}
                      fullWidth
                    >
                      <OutlinedInput
                        placeholder="Enter your password"
                        className="form-input"
                        onChange={(evt) => this.handleLoginInput(evt)}
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        autoComplete="current-password"
                        startAdornment={
                          <InputAdornment position="start">
                            <LockIcon className="input-icon" />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <button
                              type="button"
                              className="password-toggle-btn"
                              onClick={() => this.changeView()}
                              aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                              {showPassword ?
                                <VisibilityOffIcon className="password-icon" />
                              :
                                <RemoveRedEyeIcon className="password-icon" />
                              }
                            </button>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    {error.includes('password') &&
                      <p className="error-message">
                        Password is required!
                      </p>
                    }
                    {error.includes('passwordInvalid') && !error.includes('password') &&
                      <p className="error-message">
                        Password must be at least 8 characters with uppercase, lowercase, number, and special character
                      </p>
                    }
                  </div>
                  <div className="forgot-password-text">
                    <Link to="/forgotpassword" className="forgot-password-link">
                      <Typography className="forgot-password-typography">
                        Forgot password?
                      </Typography>
                    </Link>
                  </div>
                  <div className="btn-main">
                    <Button 
                      variant="contained"
                      className="login-btn"
                      onClick={() => this.handleLogin()}
                      disabled={loading}
                      fullWidth
                      type="submit"
                    >
                      {loading ?
                        <CircularProgress
                          sx={{ color: " #dad7d7 !important" }}
                          size={24}
                        />
                      :
                        "Login"
                      }
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.authReducer,
})

export default withRouter(connect(mapStateToProps, { loginUser })(LoginComp))